import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import CustomerLogin from '../components/CustomerLogin';

interface RequireAuthProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Guard Component für Authentifizierung
 *
 * Im offenen Modus: Immer durchlassen
 * Im geschlossenen Modus: Login erforderlich
 */
const RequireAuth: React.FC<RequireAuthProps> = ({ children, fallback }) => {
  const { mode, isAuthenticated, loading } = useAuth();

  // Loading state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Laden...</p>
        </div>
      </div>
    );
  }

  // Open mode - no auth required
  if (mode === 'open') {
    return <>{children}</>;
  }

  // Closed mode - check authentication
  if (!isAuthenticated) {
    return <>{fallback || <CustomerLogin />}</>;
  }

  // Authenticated
  return <>{children}</>;
};

export default RequireAuth;
